const state = {
    subCategoriesProducts: [],
    categoriesProducts: [],
    monetizationTypes:[],
    companiesById: null,
    functionalities: [],
    companyTypeId:[],
    loading: false,
    companies: [],
};

export default state;